import { z } from 'zod';
import { TimestampLike } from './common.js';

export const AuditLogDoc = z.object({
  actor: z.string().min(1),
  action: z.string().min(1),
  entityType: z.string().min(1),
  entityId: z.string().min(1),
  before: z.unknown().optional(),
  after: z.unknown().optional(),
  timestamp: TimestampLike,
});
export type AuditLogDoc = z.infer<typeof AuditLogDoc>;
